import { schema } from "normalizr";

const LeaveAllocationSchema = new schema.Entity("leaveAllocations");
const LeaveAllocationArraySchema = new schema.Array(LeaveAllocationSchema);

export { LeaveAllocationSchema, LeaveAllocationArraySchema };